//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import collapseTransition from "./component/collapseTransition";
import pagination from "./component/pagination";
import commonlist from "@/pcpage/hr/common/commonlist";
import portTree from "./component/portTree";
import * as auth from "@/utils/auth";
import * as axios from "@/store/http";
export default {
  extends: commonlist,
  name: "portList",
  components: {
    pagination,
    portTree,
    collapseTransition,
  },
  data() {
    return {
      loadRouter: "/portal/portLoad",
      locationShow: false,
      categoryShow: false,
      organizationShow: false,
      initShowAlert: false,
      openFileter: false,
      deptNodes: [],
      locationArray: [], //
      checkedLocation: [], //
      jobtitle: "", //JOB杈撳叆
      jobBandList: [],
    };
  },
  methods: {
    openFilterResult() {
      console.log("openFilter");
      this.openFileter = true;
    },
    clickDeptTree(nodeArray) {
      //
      this.queryinfo["deptids"] = nodeArray;
      this.dopagequery();
    },
    showLocation() {
      this.locationShow = !this.locationShow;
    },
    showCategory() {
      this.categoryShow = !this.categoryShow;
    },
    openOrganization() {
      this.organizationShow = !this.organizationShow;
    },
    checkChangeQuery() {
      this.queryinfo["locations"] = this.checkedLocation;
      this.dopagequery();
    },
    checkJobBandChangeQuery() {
      this.queryinfo["jobband"] = this.checkedLocation;
      this.dopagequery();
    },
    queryJobTitle() {
      this.queryinfo["jobtitle"] = this.jobtitle;
      this.dopagequery();
    },
    initSelect() {
      let params = [];
      let location = {
        showcode: "locationArray",
        selectcode: "SYS_BPROVINCE",
        hasnull: false,
        paras: {
          paras0: "PH",
        },
      };
      params.push(location);
      this.initDropDown(this, params);

      let jobBand = {
        showcode: "jobBandList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "HIRING_ENUM_THREE",
          paras1: "1",
        },
      };
      let jobBandParams = [];
      jobBandParams.push(jobBand);
      this.initDropDown(this, jobBandParams);
    },
    doRowEdit(tableRow) {
      this.$router.push({
        path: this.loadRouter,
        query: {
          uuid: tableRow.uuid,
        },
      });
    },
    openApply(tableRow) {
      let token = auth.getToken();
      if (this.isNotNullOrEmpty(token)) {
        this.checkJobInfo(tableRow.uuid);
      } else {
        this.$router.push({
          path: "/portal/login",
          query: {},
        });
      }
    },
    goTop() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    async sessionLogin() {
      let url = "api/api/portalLogin/loginSeesionAccount";
      let portalflag = this.$route.query.portalflag;
      let token = auth.getToken();
      if (portalflag == "portal") {
        auth.removeToken();
        token = "";
      }
      if (portalflag != "portal" || this.isNotNullOrEmpty(token)) {
        return true;
      }
      let params = {
        logintype: 2,
      };
      let checkpass = false;
      await axios.post(url, params).then(({ data }) => {
        if (data.code == "1") {
          let msg = data.data.msg;
          if (this.isNotNullOrEmpty(msg)) {
            this.$msgDailog
              .showMsgBox({
                title: msg,
              })
              .then(async (val) => {
                window.location.href = "about:blank";
                window.close(); //点击确定触发事件 val:返回文本域内容
              })
              .catch(() => {
                // ... 点击取消触发事件 已隐藏
              });
            return;
          }
          auth.setToken(data.data.ffToken);
          checkpass = true;
        }
      });
      return checkpass;
    },
    async checkJobInfo(uuid) {
      //验证该岗位是否未发布
      let checkUrl = "api/api/portalLogin/checkJobInfo";
      let params = {
        uuid: uuid,
      };
      await this.axios
        .post(checkUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let msg = data.data.msg;
            if (this.isNotNullOrEmpty(msg)) {
              this.$msgDailog.showMsgBox({
                title: msg,
              });
              return;
            }
            this.$router.push({
              path: "/portal/submitResume",
              query: {
                uuid: uuid,
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },
  },
  async created() {
    console.time("init");
    this.listAction = "api/api/getApplyJobList";
    this.initSelect();
    await this.sessionLogin().then(async () => {
      await this.dopagequery();
      this.initShowAlert = true;
    });
    console.timeEnd("init");
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/portList.vue